<template>
    <div class="inputs">
       <div class="column">
           <field-input v-model="form.name" placeholder="Name"></field-input>
           <field-input type="email" v-model="form.email" placeholder="Email"></field-input>
           <field-input type="password" v-model="form.password" placeholder="Password"></field-input>
           <field-input type="password" v-model="form.password_confirmation" placeholder="Password confirmation"></field-input>
           <field-input v-if="form.is_employer" v-model="form.employer_number" :readonly="true" placeholder="ATE Certified Number"></field-input>
           <field-input v-if="form.is_technician" v-model="form.att_number" :readonly="true" placeholder="ATT Certified Number"></field-input>
           <field-tags label="Notification Emails" placeholder="johndoe@email.com"  v-model="form.notification_emails" :max-tags="5"></field-tags>
       </div>
        <div class="column">
            <div class="form-group checkbox-list" v-if="authorize('admin')">
                <label>Roles</label>
                <div class="flex wrap">
                    <div class="check-item" v-for="role in roles">
                        <p-check v-model="form.roles" :value="role.id" name="check" color="success">{{ role.label }}</p-check>
                    </div>
                </div>
            </div>
            <user-image :user="form.originalData" class="mt-3"></user-image>
        </div>
    </div>
</template>

<script>
    export default {

        props: {
            form: {
                type: Object,
                required: true,
            }
        },

        data() {
            return {
                roles: [],
            }
        },

        created() {
            this.form.roles = _.map(this.form.roles, role => {
                return role.id
            })
            if(this.authorize('admin')) {
                App.request().get('/management/roles').then(response => {
                    this.roles = response.data;
                })
            }
        },
    }
</script>
